import { render, staticRenderFns } from "./InboxWindow.vue?vue&type=template&id=255c04e6"
import script from "./InboxWindow.vue?vue&type=script&lang=ts"
export * from "./InboxWindow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255c04e6')) {
      api.createRecord('255c04e6', component.options)
    } else {
      api.reload('255c04e6', component.options)
    }
    module.hot.accept("./InboxWindow.vue?vue&type=template&id=255c04e6", function () {
      api.rerender('255c04e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindow.vue"
export default component.exports